export const Live = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 12L10 7H10.8102L14 9.01428V9.98571L10.8102 12H10Z" fill="#1F2328" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 12L10 7H10.8102L14 9.01428V9.98571L10.8102 12H10Z" fill="#1F2328" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 18.5V15H19V5.5H20V4H19H5H4V5.5H5V15H11.25V18.5H8V20H16V18.5H12.75ZM6.5 5.5V13.5H17.5V5.5H6.5Z" fill="#1F2328" />
    </svg>
);
